import React from "react";

import Money from "./Money";
import { getBaseCurrency, symbolFor } from "../../core/currency";

// `currency` is a currency CODE ('gbp', 'usd', …) forwarded to <Money>.
// Omitted → the store base (Money's own default). Historically this prop
// took a display symbol and was silently ignored — it is now honoured.
const MoneyRange = ({ start, end, zero, className, currency }) => {
  if (!start && !end) {
    return (
      <div className={`d-flex ${className}`}>
        <span className="text-muted">-</span>
      </div>
    );
  }
  if (!end) {
    return (
      <div className={`d-flex ${className}`}>
        <Money amount={start} currency={currency} /> +
      </div>
    );
  }

  if (!start) {
    return (
      <div className={`d-flex ${className}`}>
        <span>{symbolFor(currency ?? getBaseCurrency())}0</span> &nbsp; - &nbsp;
        <Money amount={end} currency={currency} />
      </div>
    );
  }
  return (
    <div className={`d-flex ${className}`}>
      <Money amount={start} currency={currency} zero={0} />
      &nbsp; - &nbsp;
      <Money amount={end} currency={currency} />
    </div>
  );
};

export default MoneyRange;
